import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// import { setSearchQuery, searchColleges } from '../../store/slices/collegeSlice'; // Removed
import './SearchHeroSection.css';
import searchHeroBg from '../../assets/images/searchHeroBg.png';
import SearchBar from '../Blog/SearchBar';

const SearchHeroSection = ({ isSearchMode = false }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSearch = () => {
    if (searchTerm.trim()) {
      // Navigate with query parameter so CollegeSearchResults can read it
      navigate(`/college-finder?q=${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  return (
    <section className={`search-hero-section ${isSearchMode ? 'search-mode' : ''}`}>
      <div className="search-hero-bg-layer">
        <img src={searchHeroBg} alt="Background" className="search-hero-bg-img" />
      </div>
      
      <div className="search-hero-content">
        <h1 className="search-hero-heading">
          Find the college that<br />
          fits your future.
        </h1>
        
        <p className="search-hero-subtext">
          Make your college search easier and smarter. Browse top colleges, explore programs, compare fees, and get meaningful insights to help you choose the right path with confidence.
        </p>
        
        <div className="hero-search-wrapper">
          <SearchBar 
            placeholder="Search by courses, college name" 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onSearch={handleSearch}
            style={{ width: '100%', maxWidth: '634px' }}
          />
        </div>
        
        <div className="search-tags">
          <span className="popular-label">Popular searches: </span>
          <Link to="/college-finder?q=MBA" className="search-tag-link featured-tag" style={{ fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer', color: '#FFFFFF' }}>Top MBA Colleges</Link>,
          <Link to="/college-finder?q=Engineering" className="search-tag-link plain-tag" style={{ textDecoration: 'none', color: '#FFFFFF' }}> Top Engineering Colleges,</Link>
          <Link to="/college-finder?q=Medical" className="search-tag-link plain-tag" style={{ textDecoration: 'none', color: '#FFFFFF' }}> Top Medical Colleges,</Link>
        </div>
      </div>
    </section>
  );
};

export default SearchHeroSection;
